import React from "react"
import {AssignmentItem, AssignmentItemId, AssignmentStage} from "../../../resources/assignments"
import {CollapsedAssignmentQueueItem} from "./CollapsedAssignmentQueueItem"

interface CollapsedAssignmentQueueProps {
	assignments: AssignmentItem[]
	selectedId?: AssignmentItemId
	onSelect: (id: AssignmentItemId) => void
}

export function CollapsedAssignmentQueue({assignments, selectedId, onSelect}: CollapsedAssignmentQueueProps) {
	const pending = assignments.filter((assignment) => assignment.stage === AssignmentStage.Pending)
	const completed = assignments.filter((assignment) => assignment.stage === AssignmentStage.Completed)

	return (
		<div className="collapsed-assignment-queue">
			{pending.map((item) => (
				<CollapsedAssignmentQueueItem
					key={item.id}
					item={item}
					isSelected={item.id === selectedId}
					onSelect={onSelect}
				/>
			))}
			{pending.length > 0 && completed.length > 0 && <div className="collapsed-queue-section-divider" />}
			{completed.map((item) => (
				<CollapsedAssignmentQueueItem
					key={item.id}
					item={item}
					isSelected={item.id === selectedId}
					onSelect={onSelect}
				/>
			))}
		</div>
	)
}
